var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImballoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "imballo_yellow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "imballo_yellow"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#202020",
    strokeWidth: 1.212,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "17.5 21 22.5 21 22.5 3 17.5 3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#202020",
    strokeWidth: 1.212,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "6.5 3 1.5 3 1.5 21 6.5 21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00A7FF",
    fillRule: "nonzero",
    x: 5,
    y: 6,
    width: 14,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#202020",
    strokeWidth: 1.042,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 5,
    y: 6,
    width: 14,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImballoBlue);
export default __webpack_public_path__ + "static/media/imballo_blue.35522f9cd73d5d0b08620a929e76d725.svg";
export { ForwardRef as ReactComponent };